import common from './common.json'
import course from './course.json'
import errorMessage from './error_message.json'
import menu from './menu.json'

export default {
  common,
  course,
  error_message: errorMessage,
  menu
}
